module.exports = __webpack_public_path__ + "img/start-watch.c243773b.png";